import React from 'react';
// @ts-expect-error ts-migrate(2306) FIXME: File '/mnt/c/Users/Mark/PhpstormProjects/kmbooking... Remove this comment to see the full error message
import LoadingDots from '../LoadingDots';
import icons from '../../../markons/markons';
import Icon from '../Icon';
import css from './insights.less';
import cn from 'classnames';


const iconMap = {
    'same': icons.ionMinusRound,
    'up': icons.ionArrowUpB,
    'down': icons.ionArrowDownB,
};


export default function BillYearMonthTable({
                                               data
                                           }: any) {

    return (
        <table className="index-table no-links">
            <thead>
                <tr>
                    {/* @ts-expect-error ts-migrate(2322) FIXME: Property 'width' does not exist on type 'DetailedH... Remove this comment to see the full error message */}
                    <th width={100}>Month</th>
                    {/* @ts-expect-error ts-migrate(2322) FIXME: Property 'width' does not exist on type 'DetailedH... Remove this comment to see the full error message */}
                    <th width={90}>Total</th>
                    <th>Change</th>
                </tr>
            </thead>
            <tbody>
                {data ? data.map((row: any, i: any) => (
                    <tr key={i}>
                        <td>{row.month}</td>
                        <td>{row.total}</td>
                        <td><span className={cn(css.changePill, css[`change-${row.dir}`])}><Icon
                            name={iconMap[row.dir]}/> {row.change}</span></td>
                    </tr>
                )) : <tr>
                    <td colSpan={3}><LoadingDots center/></td>
                </tr>}
            </tbody>
        </table>
    );
}
